<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogAddClient"
    :before-close="doClose"
    width="70%"
    top="5vh"
  >
    <el-form
      :ref="refForm"
      :rules="rules"
      :model="clientform" custDialogComponent
      :label-width="$t('language.name')=='中文'?'150px':'170px'"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="$t('desc.customerName')" prop="customerName">
            <el-input v-model="clientform.customerName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="isAdd" :label="$t('title.customerCode')" prop="customerCode">
            <el-input v-model="clientform.customerCode"></el-input>
          </el-form-item>
          <el-form-item v-else :label="$t('title.customerCode')" prop="customerCode">
            <el-input disabled v-model="clientform.customerCodeShow"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item prop="brandCode" :label="$t('title.brand')">
            <el-select style="width: 100%" @change="changeBrand" v-model="clientform.brandCode" :placeholder="$t('desc.select')">
              <el-option
                :label="brandInfo.brandName"
                :value="brandInfo.brandCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="$t('title.customerTypePac')" >
            <el-select @change="changeProductLine" filterable clearable style="width: 100%" v-model="clientform.customerType" :placeholder="$t('desc.select')">
              <el-option
                v-for="item in productLineArr"
                :key="item.bnDictCode"
                :label="item.bnDictName"
                :value="item.bnDictCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('title.customerCenter')+' / '+$t('title.liaison')">
            <template slot-scope="scope">
              <el-cascader
                v-model="clientform.regionList"
                :key="(!optionRegion||optionRegion.length==0)?0:1"
                :options="optionscenter"
                style="width: 100%"
                :placeholder="$t('desc.select')"
                @change="officeChange"
                clearable
              ></el-cascader>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="$t('title.companyType')" prop="companyType">
            <el-select
              v-model="clientform.companyType"
              :placeholder="$t('desc.select')"
              style="width: 100%"
              @change="typeChange"
              clearable
            >
              <el-option value="直管" :label="$t('desc.straightPipe')"></el-option>
              <el-option value="经销商" :label="$t('desc.dealer')"></el-option>
              <el-option value="服务经销商" :label="$t('desc.serviceDistributor')"></el-option>
              <el-option value="中间商" :label="$t('desc.middleman')"></el-option>
              <el-option value="其他" :label="$t('desc.other')"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item v-if="isRequiredAgency" key="agency1" :label="$t('title.managementUnit')" prop="agencyId">
            <el-select filterable clearable style="width: 100%" v-model="clientform.agencyId" :placeholder="$t('desc.select')">
              <el-option
                v-for="item in optiongAgency"
                :key="item.id"
                :label="item.agencyName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-else key="agency2" :label="$t('title.managementUnit')">
            <el-select filterable clearable disabled style="width: 100%" v-model="clientform.agencyId" :placeholder="$t('desc.select')">
              <el-option
                v-for="item in optiongAgency"
                :key="item.id"
                :label="item.agencyName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item :label="$t('title.longitude')" >
            <el-input  v-model="clientform.longitude"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('title.latitude')" >
            <el-input  v-model="clientform.latitude"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item :label="$t('title.industry')">
            <template>
              <el-cascader
                v-model="clientform.industryList"
                :options="optionsIndustry"
                style="width: 100%"
                :placeholder="$t('desc.select')"
                clearable
              ></el-cascader>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
        <el-form-item :label="$t('title.province')+' '+$t('title.city')">
          <template>
            <el-cascader
              v-model="clientform.provinceList"
              :key="cascaderKey"
              :props="{ checkStrictly: true }"
              :options="optionRegion"
              style="width: 100%"
              :placeholder="$t('desc.select')"
              clearable
            ></el-cascader>
          </template>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item :label="$t('title.address')">
            <el-input v-model="clientform.address"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button
          v-if="subButtonAuth"
          type="success"
          :loading="loading"
          @click="onSubBtn(refForm)"
          >{{$t("button.confirm")}}</el-button
        >
        <el-button @click="doClose">{{$t("button.cancel")}}</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  
  getAgencys,
  getCustomerRegionTree,
} from "../../../api/api"
export default {
  name: "index",
  props: {
    loading:false,
    productLineArr:[],
    refForm: "",
    isAdd: true,
    subButtonAuth: false,
    clientform: {
      CustomerName: "",
      CustomerCode: "",
      CustomerCodeShow: "",
      CustomerCenter: "",
      regionList: {
        type: Array,
        default: function () {
          return [];
        },
      },
      industryList: {
        type: Array,
        default: function () {
          return [];
        },
      },
      provinceList: {
        type: Array,
        default: function () {
          return [];
        },
      },
      ManageCpName: "",
      ManageCpCode: "",
      AgencyId: "",
      ProvinceName: "",
      CityName: "",
      Address: "",
      Industry: "",
      CompanyType: "",
      Longitude:"",
      Latitude:"",
      brandCode: "IR"
    },
    dialogAddClient: false,
    dialogAddMethod: false,
    title: "",
    optionsIndustry: {
      type: Array,
      default: function () {
        return [];
      },
    },
    optionRegion: {
      type: Array,
      default: function () {
        return [];
      },
    },
    brandInfo:{},
    isRequiredAgency:false,
  },
  async mounted() {
    this.typeChange(this.clientform.companyType,this.clientform.agencyId);
  },
  computed: {
    getCustInfo: function () {
      return this.clientform;
    },
  },
  watch: {
    dialogAddMethod: {
      async handler(newValue, oldValue) {
        if (newValue === true){
          await this.changeBrand();
          this.changeProductLine();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      cascaderKey:1,
      rules: {
        brandCode:[{required:true, message: this.$t('tips.needed'), trigger: ['blur','change']}],
        customerName: [
          { required: true, message: this.$t('tips.needed'), trigger: "blur" },
        ],
        customerCode: [
          { required: true, message: this.$t('tips.needed'), trigger: "blur" },
        ],
        agencyId: [
          { required: true, message: this.$t('tips.needed'), trigger: "blur" },
        ],
        manageCpCode: [
          { required: true, message: this.$t('tips.needed'), trigger: "blur" },
        ],
        companyType: [
          { required: true, message: this.$t('tips.needed'), trigger: ["change","blur"] },
        ],
      },
      optiongAgency: [],
      agencyList: [],
      centerList:[],
      optionscenter:[],
    };
  },
  async mounted(){
    await this.getAgencys();
    await this.getCustomerRegionTree();
  },
  methods: {
    
    async getAgencys() {
      let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
      let that = this;
      let res = await getAgencys();
      let data = res.result;
      that.agencyList = data;
      that.optiongAgency=that.agencyList.filter(a=>a.brandCode==brand);
      for (let index = 0; index < that.agencyList.length; index++) {
        that.agencyList[index].agencyName =
          data[index].agencyCode + "_" + data[index].agencyName;
      }
    },
    async getCustomerRegionTree() {
      
      let that = this;
      let res = await getCustomerRegionTree();
      that.centerList=res.result;
      // that.optionscenter=that.centerList.filter(a=>a.brand==brand);
    },
    changeBrand(){
      // this.optiongAgency=this.agencyList.filter(a=>a.brandCode==this.clientform.brandCode);
      // this.optionscenter=this.centerList.filter(a=>a.brand==this.clientform.brandCode);
    },
    onSubBtn(value) {
      this.$refs[value].validate((valid) => {
        if (valid) {
          this.$emit("onSubBtn", true);
        } else {
          return false;
        }
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.$refs[this.refForm].resetFields();
    },
    officeChange(value) {
      ++this.cascaderKey;
      this.$emit("officeChange", value);
    },
    typeChange(value) {

      this.$emit("typeChange", value);
    },
    changeProductLine(){
      let that = this;
      let brand = localStorage.getItem("user_brand") ? localStorage.getItem("user_brand") : "IR"
      that.optionscenter=that.centerList.filter(a=>a.brand==brand && a.centerType == this.clientform.customerType);
    }
  },
};
</script>

<style scoped>
#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
